import FaqItem from './FaqItem';
import FaqSectionStyled from './FaqSectionStyled';
import PropTypes from 'prop-types';
import React from 'react';

const FaqSection = ({data, expandAll = true}) => {
  const {image, title, subTitle, faqList} = data;
  return (
    <FaqSectionStyled className="ecr-faqSection">
      <div className="ecrfs-left">
        <h1>{title}</h1>
        <h5>{subTitle}</h5>
        <div className="ecrfs-faq-list">
          {faqList.map((faq, index) => {
            return <FaqItem data={faq} key={index} defaultExpand={expandAll} />;
          })}
        </div>
      </div>
      <div className="ecrfs-right">
        <img src={image} alt="faq" />
      </div>
    </FaqSectionStyled>
  );
};

FaqSection.propTypes = {
  data: PropTypes.object,
  expandAll: PropTypes.bool,
};

export default FaqSection;
